export default {
  addCarProbationFeedback:
    "/gateway/huilian/carProbationFeedbackcs/addCarProbationFeedback", // 新增试用报告
  selectCarProbationFeedbackDetail:
    "/gateway/huilian/carProbationFeedbackcs/selectCarProbationFeedbackDetail", // 试用报告是否已填写
};



// WEBPACK FOOTER //
// ./src/vehicleTrialFeedbackForm/index/api.js